var map = {
	"./dgnss.jpg": 322,
	"./emds.jpg": 323,
	"./gallery-1.jpg": 324,
	"./gallery-2.jpg": 325,
	"./gallery-3.jpg": 326,
	"./gallery-4.jpg": 327,
	"./gallery-bg.png": 328,
	"./gallery-five-1.jpg": 130,
	"./gallery-five-2.jpg": 131,
	"./gallery-five-3.jpg": 132,
	"./gallery-five-4.jpg": 133,
	"./gallery-four-1.jpg": 42,
	"./gallery-four-2.jpg": 43,
	"./gallery-four-3.jpg": 44,
	"./gallery-four-4.jpg": 70,
	"./gallery-four-5.jpg": 71,
	"./gallery-four-6.jpg": 72,
	"./gallery-four-7.jpg": 73,
	"./gallery-four-8.jpg": 74,
	"./gallery-img.jpeg": 329,
	"./gallery-three-1.jpg": 86,
	"./gallery-three-2.jpg": 87,
	"./gallery-three-3.jpg": 88,
	"./gallery-three-4.jpg": 330,
	"./gallery-three-5.jpg": 331,
	"./gallery-three-6.jpg": 332,
	"./gallery-three-7.jpg": 333,
	"./gallery-three-8.jpg": 334,
	"./gallery-three-9.jpg": 335,
	"./gallery-two-1.jpg": 89,
	"./gallery-two-2.jpg": 90,
	"./gallery-two-3.jpg": 91,
	"./ndnu.jpg": 336,
	"./portfolio-details.jpg": 176,
	"./portfolio-middle-1.jpg": 177,
	"./portfolio-middle-2.jpg": 178,
	"./project1.jpg": 123,
	"./project2.jpg": 124,
	"./project3.jpg": 125,
	"./project4.jpg": 126,
	"./sbms.jpg": 337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 179;